import * as React from "react";
const SvgUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 4, viewBox: "0 0 5 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 0L0 4H5L2.5 0Z", fill: "currentColor" }));
export default SvgUp;
